import { graphql } from "api/cms-website/generated";

export const AdvantagesWithHeadingFragment = graphql(/* GraphQL */ `
    fragment AdvantagesWithHeadingFragment on ComponentComponentsAdvantagesWithHeading {
        id
        noMarginBottom
        advantagesWithHeadingTitle: title
        subtitle
        advantagesWithHeadingCta: cta {
            ...ButtonFragment
        }
        advantagesWithHeadingAdvantages: advantages {
            ...AdvantagesWithHeadingItemFragment
        }
    }
`);
